import { useState } from 'react'
import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/topics/TitleGroup/TitleGroup'
import styles from '../../Topics.module.scss'
import Link from 'next/link'
import { formatCreateDate } from 'lib/functions'
import Pagination from 'components/topics/Pagination'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import CaseStudy from 'components/home/CaseStudy'
import EventSlider from 'components/topics/EventSlider'
import Button from 'components/commons/Button/Button'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = [
  {
    y: 50,
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    y: 100,
    duration: 1.2,
    opacity: 0,
    ease: Power4.easeOut,
  },
  { duration: 0, width: 0, ease: Power4.easeOut, border: '0 #ffff' },
  { duration: 2, width: '100%', border: '0.1px solid #eeeeee' },
]

const TopicsPressRelease = ({ posts, page, totalPageNumber, activeEvents }) => {
  const pageId = parseInt(page)
  const currentPage = pageId
  const [totalPages] = useState(totalPageNumber)

  const getPageLink = (pageNo) => {
    return `/pressrelease/page/${pageNo}`
  }

  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Topics', url: '/pressrelease/page/1' },
    { name: 'Press release', url: '#' },
  ]

  const list = []
  for (let i = 0; i < posts.length; i++) {
    list.push(
      <Link
        href={{ pathname: `/pressrelease/${posts[i].id}`, query: { page: currentPage } }}
        as={`/pressrelease/${posts[i].id}`}
        key={posts[i].id}
      >
        <a className={styles.list_wrapper}>
          <div className={styles.flexlist}>
            <figure className={styles.flexlist_thumbnail}>
              <img
                src={posts[i].thumbnail_img || '/images/img/thumbnail_noimg.webp'}
                alt={posts[i].title.rendered || 'デフォルト画像'}
              />
            </figure>
            <div className={styles.listcontent}>
              <div className={styles.status}>
                <span className={styles.status_day}>{`${formatCreateDate(posts[i].date)}`}</span>
              </div>
              <div className={styles.textWrap}>
                <p className={styles.topic_title}>{posts[i].title.rendered}</p>
              </div>
              <span className={styles.topic_arrow}></span>
            </div>
          </div>
        </a>
      </Link>,
    )
  }

  const timeline = gsap.timeline()
  const contents = useRef<HTMLDivElement>()
  const button = useRef<HTMLDivElement>()

  useEffect(() => {
    Array.prototype.forEach.call(contents.current.children, (element: HTMLElement, index: number) => {
      timeline
        .from(element.children[0], tweenVars[0], 1 + index * 0.3)
        .fromTo(element.children[1], tweenVars[2], tweenVars[3], 1.2 + index * 0.3)
    })
    timeline.from(button.current, tweenVars[0], 1.5)

    ScrollTrigger.create({
      animation: timeline,
      trigger: contents.current,
      start: 'top-=250 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <EventSlider activeEvents={activeEvents} />
      <div className={styles.content} id="paginationTarget">
        <div className={styles.news_group}>
          <ul className={styles.tab}>
            <li className={styles.currentCategory}>
              <a>Press release</a>
            </li>
            <Link href="/news/page/1" scroll={false}>
              <li className={styles.category}>
                <a>News</a>
              </li>
            </Link>
            <Link href="/events/page/1" scroll={false}>
              <li className={styles.category}>
                <a>Event/Seminar</a>
              </li>
            </Link>
          </ul>
          <div ref={contents}>{list}</div>
          <div className={styles.pagination}>
            <Pagination currentPage={currentPage} totalPages={totalPages} getPageLink={getPageLink} />
          </div>
        </div>
        <div className={styles.mailmagazine_link}>
          <p>
            UX/UIデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベントや最新事例などをお届けします。
          </p>
          <div className={styles.mailmagazine_link_button}>
            <Button text="メールマガジン" href="/mailmagazine" red="red" />
          </div>
        </div>
      </div>
      <CaseStudy tagType="h2" />
      <MailmagazineLink />
    </section>
  )
}

export default TopicsPressRelease
